"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InstallationPanelBody = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _ConsumerAppInstallationPanel = _interopRequireDefault(require("./ConsumerAppInstallationPanel"));

var _PanelItems = require("../PanelItems");

var _Message = require("../../../ui-components/Message");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _RadioInputGroup = _interopRequireDefault(require("@insided/shared/uikit/RadioInputGroup"));

var _classnames = _interopRequireDefault(require("classnames"));

var _common = require("@insided/shared/utils/common");

var APPEXCHANGE_URL_PRODUCTION = 'https://appexchange.salesforce.com/appxListingDetail?listingId=d4c625a1-8006-454a-b840-d50e1ac8bb9b';
var APPEXCHANGE_URL_SANDBOX = 'https://login.salesforce.com/packaging/installPackage.apexp?p0=04tNS000000H0ZtYAK';
var LEARN_MORE_URL = 'https://community.insided.com/integrations-124/how-to-install-the-salesforce-x-insided-integrations-3932';

var isSalesforceSandboxEnabled = _common.common.isModuleActive('salesforceSandbox');

var InstallationPanelBody = function InstallationPanelBody(_ref) {
  var isInstalled = _ref.isInstalled,
      isProduction = _ref.isProduction,
      instanceTypes = _ref.instanceTypes,
      onSave = _ref.onSave,
      type = _ref.type,
      username = _ref.username,
      instanceUrl = _ref.instanceUrl,
      appConsumerKey = _ref.appConsumerKey,
      isOauthEnabled = _ref.isOauthEnabled,
      _onClickManage = _ref.onClickManage,
      _onClickUninstall = _ref.onClickUninstall,
      onInstanceTypeChangeCallback = _ref.onInstanceTypeChangeCallback;

  if (!isOauthEnabled) {
    return (0, _preact.h)("div", {
      className: (0, _classnames.default)('panel-body-container', 'installation__panel_body', 'non-editable__panel_body')
    }, (0, _preact.h)(_ConsumerAppInstallationPanel.default, {
      instanceTypes: instanceTypes,
      instanceUrl: instanceUrl,
      username: username,
      appConsumerKey: appConsumerKey,
      type: type
    }), (0, _preact.h)(_PanelItems.ManageInstallationButtons, {
      onClickManage: function onClickManage() {
        return _onClickManage();
      },
      onClickUninstall: function onClickUninstall() {
        return _onClickUninstall();
      }
    }));
  }

  if (isInstalled) {
    return (0, _preact.h)("div", {
      className: (0, _classnames.default)('panel-body-container', 'installation__panel_body', 'sf-oauth-installation')
    }, (0, _preact.h)("p", {
      className: "sf-oauth-installation__step-description"
    }, "This app is already installed, go to Integration tab to manage it."), (0, _preact.h)("div", {
      className: "sf-oauth-installation__buttons"
    }, (0, _preact.h)(_Button.default, {
      size: "medium",
      variant: "brand",
      title: "Go to Salesforce Integration",
      onClick: function onClick() {
        return _onClickManage();
      }
    }), (0, _preact.h)(_Button.default, {
      size: "medium",
      variant: "secondary",
      title: "Uninstall App",
      onClick: function onClick() {
        return _onClickUninstall();
      }
    })));
  }

  return (0, _preact.h)("div", {
    className: (0, _classnames.default)('panel-body-container', 'installation__panel_body', 'sf-oauth-installation')
  }, (0, _preact.h)("div", {
    className: "sf-oauth-installation__step"
  }, (0, _preact.h)("h3", {
    className: "sf-oauth-installation__step-title"
  }, "STEP 1 - Install Salesforce Package"), (0, _preact.h)("p", {
    className: "sf-oauth-installation__step-description"
  }, "Install the package on Salesforce AppExchange to continue."), (0, _preact.h)(_Button.default, {
    size: "medium",
    variant: "secondary",
    title: "Go to AppExchange",
    onClick: function onClick() {
      return window.open(isProduction ? APPEXCHANGE_URL_PRODUCTION : APPEXCHANGE_URL_SANDBOX, '_blank', 'noopener,noreferrer');
    }
  })), (0, _preact.h)("div", {
    className: "sf-oauth-installation__step"
  }, (0, _preact.h)("h3", {
    className: "sf-oauth-installation__step-title"
  }, "STEP 2 - Set Up Integration"), (0, _preact.h)(_Message.Message, {
    variant: "info",
    text: (0, _preact.h)("span", null, "Before continuing, make sure the ", (0, _preact.h)("strong", null, "Salesforce package is installed."))
  }), (0, _preact.h)("p", {
    className: "sf-oauth-installation__step-description"
  }, "To install the Salesforce integration, you need a Salesforce profile with the required user permissions or Salesforce System Administrator access.", ' ', (0, _preact.h)("a", {
    href: (0, _absoluteUrlRuntime.resolveUrl)(LEARN_MORE_URL),
    target: "_blank",
    rel: "noreferrer",
    className: "overview-page-link"
  }, "Learn more")), (0, _preact.h)("p", {
    className: "sf-oauth-installation__step-description"
  }, "After installing the package, continue with the integration setup."), isSalesforceSandboxEnabled && (0, _preact.h)("div", {
    className: "panel-form-input qa-form-type"
  }, (0, _preact.h)(_RadioInputGroup.default, {
    title: "Salesforce instance type",
    options: instanceTypes,
    required: true,
    disabled: isInstalled,
    onChange: function onChange(option) {
      return onInstanceTypeChangeCallback(option);
    },
    value: type,
    underneath: true
  })), (0, _preact.h)(_Button.default, {
    size: "medium",
    variant: "brand",
    title: "Install Salesforce Integration",
    onClick: function onClick() {
      return onSave();
    }
  })));
};

exports.InstallationPanelBody = InstallationPanelBody;